// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2rOgZ","banner":"style_banner__3nrAs","logo":"style_logo__GXL1K","room-cards":"style_room-cards__xQge9","loading":"style_loading__PVkoB"};